module.exports = __webpack_public_path__ + "media/images/icons/inquiry-icon-c3abbb32bbd72e6128cb3b563080f2d3.svg";